module.exports = __webpack_public_path__ + "static/img/zerb-mob-5.ef199c8.webp";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/zerb-mob-5.webp
// module id = w7h9
// module chunks = 22